export const standBooking = {
  companyStep: {
    title: "Erster Step",
    company: {
      title: "Erste Form",
      fields: {
        language: "Bitte wählen Sie die gewünschte Korrespondenzsprache:",
        exhibitor: "Name des Hauptausstellers (Auftraggeber)",
        street: "Straße",
        houseNumber: "Hausnummer",
        zip: "Postleitzahl",
        city: "Stadt",
        country: "Land",
        website: "Webseite",
        email: "E-Mail (Unternehmen)",
        phone: "Telefon",
        fax: "Fax",
        exhibitorDesignName:
          "Mit welchem Namen soll der Mitaussteller im Ausstellerverzeichnis aufgeführt werden?",
      },
    },
  },
  buttons: {
    back: "Zurück",
    next: "Nächster Schritt",
    draft: "Entwurf speichern",
    saveNewDraft: "Als neuen Entwurf speichern",
    finish: "Verbindlich absenden",
  },
}
